import classNames from 'classnames';
import React, { Fragment, useMemo } from 'react';
import styles from "./SegmentedControl.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SegmentedControl = ({
  active,
  elements,
  variant = 'FILLED',
  backgroundStyle = 'GRAY',
  onChange,
  className
}) => {
  const items = useMemo(() => {
    const activeIndex = elements.findIndex(({
      id
    }) => id === active);
    return elements.map((el, index) => {
      const isSeparatorHidden = variant === 'TEXT' ? false : index === activeIndex || index === activeIndex - 1;
      const isLastIndex = index === elements.length - 1;
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsxs("button", {
          type: "button",
          className: classNames(styles.option, {
            [styles.active]: el.id === active,
            [styles.disabled]: el.disabled
          }),
          onClick: () => !el.disabled && onChange?.(el.id),
          disabled: el.disabled,
          children: [/*#__PURE__*/_jsx("span", {
            className: styles.visibleContent,
            children: el.displayName
          }), /*#__PURE__*/_jsx("span", {
            className: styles.invisibleContent,
            "aria-hidden": true,
            children: el.displayName
          })]
        }), !isLastIndex && /*#__PURE__*/_jsx("span", {
          className: classNames(styles.seperator, {
            [styles.hidden]: isSeparatorHidden
          })
        })]
      }, el.id);
    });
  }, [active, elements, onChange, variant]);
  return /*#__PURE__*/_jsx("div", {
    className: classNames(className, styles.segmentedControl, styles[variant], styles[backgroundStyle]),
    children: items
  });
};